import script from "./ImageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageComponent.vue?vue&type=script&setup=true&lang=js"

import "./ImageComponent.vue?vue&type=style&index=0&id=4aa86497&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa86497"]])

export default __exports__